export default __webpack_public_path__ + "static/media/KE.22bc5aeb.svg";